import { type WorkflowData, type UnsavedWorkflow, type WorkflowAddInput, type WorkflowAddSuccess } from '@terros/common'
import { useTantalimMutation } from '../mutation'
import { type AddHookResponse, mutationAdd } from '../hooks'
import { useWorkflowCache } from './cache'

export function useAddWorkflow(): AddHookResponse<UnsavedWorkflow, WorkflowData> {
  const cache = useWorkflowCache()
  const mutation = useTantalimMutation<WorkflowAddInput, WorkflowAddSuccess>({ url: '/workflow/add' })

  async function add(workflow: UnsavedWorkflow): Promise<WorkflowData> {
    const output = await mutation.mutateAsync({ workflow })
    cache.clearList()
    cache.clearReportColumns()
    return output.workflow
  }

  return mutationAdd(mutation, add)
}
